import { useEffect, useState, useRef } from 'react'

import { Flex } from '@react-css/flex'
import axios from 'axios'

import { User } from '../../../../api/types'
import { useBuildingContext } from '../../../../contexts/buildingContext'
import { useNotifications } from '../../../../contexts/notificationProvider'
import { useTagContext } from '../../../../contexts/tagContext'
import { useUserContext } from '../../../../contexts/userContext'
import { globalErrorHandler } from '../../../../globalErrorHandler'
import { getFullName } from '../../../../utils'
import { InitialsAvatar } from '../../InitialsAvatar'

import {
  CreateButtonContainer,
  UserEmail,
  UserListContainer,
  UserListScrollContainer,
  SearchBar,
  CreateButton,
} from './styles'

const BASE_URL = process.env.REACT_APP_NEXTERA_API

interface IUserListListProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper users type
  users: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper toggleSelectedUser type
  toggleSelectedUser: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper selectedUsers type
  selectedUsers: any
}
const UserListList = ({
  users,
  toggleSelectedUser,
  selectedUsers,
}: IUserListListProps) => {
  const { state: userState } = useUserContext()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper user type
  return users.map((user: any) => {
    if (user.public_id !== userState.public_id) {
      return (
        <UserListItem
          toggleSelectedUser={toggleSelectedUser}
          user={user}
          selectedUsers={selectedUsers}
          key={Math.random()}
        />
      )
    }
    return <></>
  })
}

interface IUserListItemProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper toggleSelectedUser type
  toggleSelectedUser: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper user type
  user: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper selectedUsers type
  selectedUsers: any
}
const UserListItem = ({
  toggleSelectedUser,
  user,
  selectedUsers,
}: IUserListItemProps) => {
  const [selected, setSelected] = useState<boolean>(false)
  const firstUpdate = useRef(true)

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
    } else {
      toggleSelectedUser(user.public_id)
    }
    // eslint-disable-next-line
  }, [selected])

  useEffect(() => {
    if (selectedUsers.includes(user.public_id)) {
      setSelected(true)
      firstUpdate.current = true
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Flex
      flexDirection="row"
      onClickCapture={() => setSelected(!selected)}
      // onMouseDown={() => setSelected(!selected)}
      key={Math.random()}
      className={
        selected
          ? 'selected-chat-user pnlm-ignore oco-dialogue'
          : 'pnlm-ignore oco-dialogue'
      }
      style={{
        alignItems: 'center',
        borderBottom: '1px solid #e8e8e8',
        padding: '5px 0',
        cursor: 'pointer',
      }}
    >
      <InitialsAvatar
        user={{
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          userId: user.public_id,
        }}
        theme="dark"
      />
      <p>
        {getFullName({
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          userId: user.public_id,
        })}
        <br />
        <UserEmail>{user.email}</UserEmail>
      </p>
    </Flex>
  )
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper props type
export const ChatUserSelect = (props: any) => {
  const { addNotification } = useNotifications()
  const { state: userState } = useUserContext()
  const { state: buildingState } = useBuildingContext()
  const { updateChat } = useTagContext()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper user array type
  const [users, setUsers] = useState<Array<any>>([])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper user array type
  const [filteredUsers, setFilteredUsers] = useState<Array<any>>([])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper user array type
  const [selectedUsers, setSelectedUsers] = useState<Array<any>>([])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper user type
  const toggleSelectedUser = (user: any) => {
    if (selectedUsers.includes(user)) {
      setSelectedUsers(prevState => {
        const userIndex = prevState.findIndex(item => item === user)
        prevState.splice(userIndex, 1)
        return prevState
      })
    } else {
      setSelectedUsers(prevState => {
        prevState.push(user)
        return prevState
      })
    }
  }

  const getProjectUsers = (projectId: string) => {
    axios
      .get(`${BASE_URL}/project/${projectId}/workers`)
      .then(r => {
        const users = r.data.data.map(
          (item: { added_on: string; user: User }) => item.user,
        )
        setUsers(users)
        setFilteredUsers(users)
      })
      .catch(err => globalErrorHandler(err))
  }

  const createAction = () => {
    if (selectedUsers.length > 0) {
      const addCurrentUser = selectedUsers.concat(userState.public_id)
      updateChat({ status: 'conversation', users: addCurrentUser })
      props.onCreate(addCurrentUser)
    } else {
      addNotification('Please select at least one user', 'error')
    }
  }

  const filterUsers = (query: string) => {
    const usersSearch = users.filter(
      user =>
        user.email.toLowerCase().includes(query.toLowerCase()) ||
        user.first_name?.toLowerCase().includes(query.toLowerCase()) ||
        user.last_name?.toLowerCase().includes(query.toLowerCase()),
    )
    setFilteredUsers(usersSearch)
  }

  useEffect(() => {
    getProjectUsers(buildingState.projectId)
    // eslint-disable-next-line
  }, [])

  return (
    <UserListContainer id="ul-c" className="pnlm-ignore oco-dialogue">
      <SearchBar
        placeholder="Search users"
        onChange={e => filterUsers(e.target.value)}
      />
      <UserListScrollContainer className="pnlm-ignore oco-dialogue">
        <UserListList
          users={filteredUsers}
          toggleSelectedUser={toggleSelectedUser}
          selectedUsers={selectedUsers}
        />
      </UserListScrollContainer>
      <Flex
        flexDirection="row"
        style={{
          position: 'absolute',
          bottom: '0',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '90%',
        }}
      >
        <CreateButtonContainer>
          <CreateButton onClick={() => createAction()}>
            Create Chat
          </CreateButton>
        </CreateButtonContainer>
      </Flex>
    </UserListContainer>
  )
}
